import _ from 'underscore';
import { Scopes } from './config/constants';

export const convertToMTFormat = (campaignId, goalScopeSelection, originalGoalSelection, goalSelection, isSelectorEnabled) => {
  if (!isSelectorEnabled) {
    return [];
  }
  const mtFormat = (goal, isAdd) => (
    {
      Action: isAdd ? 'Add' : 'Delete',
      GoalId: goal.Id,
      Name: goal.Name,
      CampaignId: campaignId,
      SubType: 'Goal',
    }
  );

  const mtFormatGoals = [];

  if (goalScopeSelection === Scopes.ACCOUNT) {
    // remove all existing goals
    _.forEach(originalGoalSelection, (goal) => {
      mtFormatGoals.push(mtFormat(goal, false));
    });
  } else {
    const originalIdSet = {};
    _.forEach(originalGoalSelection, (goal) => { originalIdSet[goal.Id] = true; });

    const selectionIdSet = {};
    _.forEach(goalSelection, (goal) => { selectionIdSet[goal.Id] = true; });

    _.forEach(originalGoalSelection, (goal) => {
      // remove
      if (!selectionIdSet[goal.Id]) {
        mtFormatGoals.push(mtFormat(goal, false));
      }
    });
    _.forEach(goalSelection, (goal) => {
      // add
      if (!originalIdSet[goal.Id]) {
        mtFormatGoals.push(mtFormat(goal, true));
      }
    });
  }

  return mtFormatGoals;
};
